export default {
  layoutSelectors: ["#billing_email"],
  inputIdentifier: "#billing_email",
  label: "billing checkout (email)"
}
